import './App.css';
import { useEffect } from "react";
import LandingPage from './pages/LandingPage';
import UploadAudioVideo from './pages/restricted/uploadFile/UploadAudioVideo';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './pages/restricted/ProtectedRoute';
import ProcessingFile from './pages/restricted/uploadFile/ProcessingFile';
import { ToastContainer, toast } from 'react-toastify';

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./store";
import { logout } from './features/authSlice';
import { IdleTimerProvider, useIdleTimer } from "react-idle-timer";
import AfterLogin from './pages/restricted/AfterLogin';
import PreviousMeetingsDetails from './pages/restricted/previousMeetings/PreviousMeetingsDetails';
import PreviousMeetingSingle from './pages/restricted/previousMeetings/PreviousMeetingSingle';
import DashboardLanding from './pages/dashboard/DashboardLanding';
import MeetingAuthPage from './pages/MeetingAuthPage';
import { useHeartbeat } from './hooks/useHeartbeat';
import DraftMeetingDetails from './pages/restricted/draftMeetings/DraftMeetingDetails';
import DraftMeetingSingle from './pages/restricted/draftMeetings/DraftMeetingSingle';

function IdleWatcher({ getRemainingTime, reset, isAuthenticated }: any) {

  useEffect(() => {
    if (!isAuthenticated) return;
    reset();
    const interval = setInterval(() => {
    }, 1000);

    return () => clearInterval(interval);
  }, [getRemainingTime, isAuthenticated, reset]);

  return null;
}

function App() {
  useHeartbeat();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  const handleOnIdle = () => {
    if (isAuthenticated) {
      toast.warn("Session expired. You have been logged out.");
      dispatch(logout());
    }
  };

  const { getRemainingTime, reset } = useIdleTimer({
    onIdle: handleOnIdle,
    timeout: 1_800_000, // 30 seconds
    debounce: 500,
  });

  useEffect(() => {
    if (!isAuthenticated) {
      reset();
    }
  }, [isAuthenticated, reset]);

  return (
    <IdleTimerProvider
      timeout={30 * 60 * 1000}
      onIdle={handleOnIdle}
      debounce={500}
    >
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard-landing" element={<DashboardLanding />} />
          <Route path="/meeting-authentication" element={<MeetingAuthPage />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/upload" element={<UploadAudioVideo />} />
            <Route path="/processing" element={<ProcessingFile />} />
            <Route path="/afterLogin" element={<AfterLogin />} />
            <Route path="/previousMeetingsDetails" element={<PreviousMeetingsDetails />} />
            <Route path="/meeting-details/:taskId" element={<PreviousMeetingSingle />} />

            <Route path="/draftMeetingsDetails" element={<DraftMeetingDetails />} />
            <Route path="/draft-meeting/:taskId" element={<DraftMeetingSingle />} />


          </Route>
        </Routes>

        <ToastContainer position="top-center" />

        {isAuthenticated && (
          <IdleWatcher
            getRemainingTime={getRemainingTime}
            reset={reset}
            isAuthenticated={isAuthenticated}
          />
        )}
      </Router>
    </IdleTimerProvider>
  );
}

export default App;
